export default defineNuxtPlugin(async () => {
  const appConfigStore = useAppConfigStore()
  await appConfigStore.loadAppConfig()
})
